var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.99985,1.5 C17.79885,1.5 22.49985,6.201 22.49985,12 C22.49985,17.799 17.79885,22.5 11.99985,22.5 C6.20085,22.5 1.49985,17.799 1.49985,12 C1.49985,6.201 6.20085,1.5 11.99985,1.5 Z M11.99985,3 C7.0371,3 2.99985,7.03725 2.99985,12 C2.99985,16.96275 7.0371,21 11.99985,21 C16.9626,21 20.99985,16.96275 20.99985,12 C20.99985,7.03725 16.9626,3 11.99985,3 Z M15.2196,7.719675 L16.2801,8.780175 L13.06035,11.999925 L16.2801,15.219675 L15.2196,16.280175 L11.99985,13.060425 L8.7801,16.280175 L7.7196,15.219675 L10.93935,11.999925 L7.7196,8.780175 L8.7801,7.719675 L11.99985,10.939425 L15.2196,7.719675 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutline);
export default __webpack_public_path__ + "static/media/Close Outline.6a4bb43357e3c12858e34287c1691f42.svg";
export { ForwardRef as ReactComponent };